/**
 * Stream depth, in-flight and lag.
 *
 * The three columns answer different questions and the distinction matters:
 * `pending` is claimed-but-unacked (a stuck consumer), `lag` is never-read (a
 * slow one). Discovery starving the video stream during the load test showed as
 * lag 998k with pending flat at 1,000 — one number alone would not have said it.
 */
import { useQueues } from '../api/queries'
import { PanelState, Pill, Tile } from '../components/ui'
import { n } from '../components/format'

export function Queues() {
  const { data, isLoading, error } = useQueues()
  return (
    <Tile title="Streams" hint="depth / pending / lag">
      <PanelState isLoading={isLoading} error={error}>
        <table className="t">
          <thead>
            <tr><th>stream</th><th className="n">depth</th><th className="n">pending</th><th className="n">lag</th></tr>
          </thead>
          <tbody>
            {data?.streams.map((s) => {
              const dead = s.stream === 'dead_letter'
              return (
                <tr key={s.stream}>
                  <td>{s.stream}</td>
                  <td className="n" style={dead && s.depth === 0 ? { color: 'var(--ok)' } : undefined}>
                    {dead && s.depth > 0 ? <Pill state="crit">{n(s.depth)}</Pill> : n(s.depth)}
                  </td>
                  <td className="n q">{n(s.pending)}</td>
                  <td className="n q">{n(s.lag)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </PanelState>
    </Tile>
  )
}
